module.exports = __webpack_public_path__ + "static/media/expensify.388dfb45.png";